module.exports = __webpack_public_path__ + "static/media/trade_icon.a9b593e5.svg";